import { dateToUsFormat } from "./dateToUsFormat";

export function formatDateField<T, K extends keyof T>(
  data: T | undefined,
  field: K,
  fallback: string = "-",
): string | undefined {
  if (data === undefined || data === null) return fallback;

  const value = data[field];

  return typeof value === "string" && value ? dateToUsFormat(value) : fallback;
}
